<template>
  <FlotoDrawer open @hide="$emit('hide')">
    <template v-slot:title>
      {{ $tc('chat') }}
    </template>
    <div v-if="room.user" class="flex flex-col flex-1">
      <FlotoFixedView :gutter="0">
        <div class="h-100 flex flex-col">
          <div class="flex flex-col">
            <div class="flex items-center">
              <div>
                <FlotoUserAvatar :size="70" :avatar="room.user.avatar" />
              </div>
              <div class="ml-4">
                <h3 class="mb-0">
                  {{ room.user.name }}
                </h3>
                <small>
                  <a :href="`mailto:${room.user.email}`">
                    {{ room.user.email }}
                  </a>
                </small>
              </div>
            </div>
            <MDivider />
            <div class="flex flex-col">
              <h6 class="m-0 text-neutral-light">
                {{ $tc('technician', room.technicians.length) }}
              </h6>
              <div class="flex items-center flex-wrap">
                <FlotoTechnicianPicker
                  v-if="room.technicians.length"
                  :value="collaboratorId || room.technicians[0]"
                  disabled
                />
              </div>
            </div>
          </div>
          <MDivider class="mb-2" />
          <div class="h-100 mb-4 rounded overflow-hidden flex flex-col">
            <div class="my-4 chat-area flex flex-col min-h-0">
              <AIBotChatMessages
                v-if="aiBot"
                show-no-data
                :owner="chatOwner"
                :room="room"
                :requester="room.user"
              />
              <ChatMessages
                v-else
                show-no-data
                :owner="chatOwner"
                :room="room"
                :requester="room.user"
              />
            </div>
          </div>
        </div>
      </FlotoFixedView>
    </div>
  </FlotoDrawer>
</template>

<script>
import ChatMessages from '@components/chat/chat-box/chat-messages.vue'
import AIBotChatMessages from '@components/chat/ai-bot/ai-bot-chat-messages'
import { TechnicianComputed } from '@state/modules/technician'
import { getUserApi } from '@modules/users/users-api'
import { authComputed } from '@/src/state/modules/auth/helpers'

export default {
  name: 'ChatHistory',
  components: { ChatMessages, AIBotChatMessages },
  props: {
    room: { type: Object, required: true },
    chatTechnicianId: { type: Number, default: undefined },
    collaboratorId: { type: Number, default: undefined },
    aiBot: { type: Boolean, default: false },
    myChatHistory: { type: Boolean, default: false },
  },
  data() {
    return {
      chatTechnician: {},
    }
  },
  computed: {
    ...authComputed,
    ...TechnicianComputed,
    chatOwner() {
      if (this.myChatHistory) {
        return this.user
      }
      return this.chatTechnician
    },
  },
  created() {
    const technicianId = this.chatTechnicianId || this.room.technicians[0]
    if (this.aiBot) {
      this.chatTechnician = this.room.user
    }
    if (technicianId) {
      const technician = this.technician(technicianId)
      if (!technician.id) {
        getUserApi('technician', technicianId, {
          params: {
            archived: true,
          },
        }).then((data) => {
          this.chatTechnician = data
        })
      } else {
        this.chatTechnician = technician
      }
    }
  },
}
</script>
